import Vue from "vue";
import Router from "vue-router";
import Layout from '@/views/Layout'
import ResponseFooter from "components/response-footer";
import listFooter from "components/list-footer";
import api from '@/api';
import store from "./store";

Vue.use(Router);
    
const routes = [
    {
        path: "/",
        redirect: "/home",
        name: '大会首页',
        // component: resolve => require(['@/views/Layout'], resolve), //懒加载
        components: {
            default: resolve => require(['@/views/Layout'], resolve), //懒加载
            footer: ResponseFooter
        },
        children: [
            {
                path: "/home",
                // component: resolve => require(['@/views/Index'], resolve), //懒加载
                components: {
                    default: resolve => require(['@/views/NewIndex'], resolve), //懒加载
                    // default: resolve => require(['@/views/qidai'], resolve), //懒加载
                },
                meta: {
                    keepAlive: true
                },
                name: '大会首页',
            },
            {
                path: "/agenda",//大会议程
                components: {
                    default: resolve => require(['@/views/NewAgenda'], resolve), //懒加载
                },
                name: '大会议程',
            },
            {
                path: "/news",//热门资讯
                components: {
                    default: resolve => require(['@/views/NewHotNews'], resolve), //懒加载
                },
                name: '热门资讯',
            },
            {
                path: "/partner",//生态伙伴
                components: {
                    default: resolve => require(['@/views/NewPartner'], resolve), //懒加载
                },
                name: '生态伙伴',
            },
            {
                path: "/video",//精彩视频
                components: {
                    default: resolve => require(['@/views/NewVideo'], resolve), //懒加载
                },
                name: '精彩视频',
            },
            // 隐私政策
            {
                path: '/privacy',
                components: {
                    default: resolve => require(['@/views/privacy'], resolve), //懒加载
                },
                name: '隐私政策',
            },
            {
                path: '/exhibition',// 展厅导览
                components: {
                    default: resolve => require(['@/views/ExhibitionGuide'], resolve), //懒加载
                },
            }, 
            {
                path: '/exhibitionDetail',// 展厅导览详情
                components: {
                    default: resolve => require(['@/views/ExhibitionGuideDetail'], resolve), //懒加载
                },
            }, 
            {
                path: '/my',// 个人 中心
                components: {
                    default: resolve => require(['@/views/NewPersonal'], resolve), //懒加载
                },
            },
            {
                path: "/guest",//重磅嘉宾
                // component: resolve => require(['@/views/guest'], resolve), //懒加载
                components: {
                    default: resolve => require(['@/views/newGuest'], resolve), //懒加载
                    // footer: listFooter
                },
            },
            // {
            //     path: '/news/newsDetail',
            //     // component: resolve => require(['@/views/newsdetail'], resolve), //懒加载
            //     components: {
            //         default: resolve => require(['@/views/newsdetail'], resolve), //懒加载
            //         footer: listFooter
            //     },
            // },
            {
                path: "/guide",//参会指南
                // component: resolve => require(['@/views/guide'], resolve), //懒加载
                components: {
                    default: resolve => require(['@/views/NewGuide'], resolve), //懒加载
                    // footer: listFooter
                },
            },
            // {
            //     path: "/exhibition",
            //     name: "exhibition",
            //     // component: resolve => require(['@/views/exhibition'], resolve), //懒加载
            //     components: {
            //         default: resolve => require(['@/views/exhibition'], resolve), //懒加载
            //         footer: listFooter
            //     },
            //     meta: {
            //         keepAlive: false
            //     }
            // },
            // {
            //     path: '/exhibition/samplePoint',
            //     name: "samplePoint",
            //     // component: resolve => require(['@/views/samplePoint'], resolve), //懒加载
            //     components: {
            //         default: resolve => require(['@/views/samplePoint'], resolve), //懒加载
            //         footer: listFooter
            //     },
            // },
            // {
            //     path: '/exhibition/exhibitionDetail',
            //     name: "exhibitionDetail",
            //     // component: resolve => require(['@/views/exhibitionDetail'], resolve), //懒加载
            //     components: {
            //         default: resolve => require(['@/views/exhibitionDetail'], resolve), //懒加载
            //         footer: listFooter
            //     },
            // },
            {
                path: '/files',
                // component: resolve => require(['@/views/guide'], resolve), //懒加载
                components: {
                    default: resolve => require(['@/views/NewFiles'], resolve), //懒加载
                    // footer: listFooter
                },
            },
            
        ]
    },
]

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_FLAG === 'pro' ? "/campaign/partner2021-minisite-1/" : "/campaign/uat/partner2021-minisite-1/",
    /* base: "/campaign/ecopartner2020/", //正式配置*/
    scrollBehavior: () => ({y: 0}),
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router.beforeEach(async (to, from, next) => {
    // NProgress.start();

    // 获取服务器时间
    if(!window.ec_time_request){
        api.getTime()
        .then(res=>{
            if(res.result == 0){
                // let currentTime = res.content.serverTime * 1;
                let currentTime = 0;
                if(process.env.VUE_APP_FLAG === 'pro'){
                    currentTime = res.content.serverTime * 1;
                }else{
                    currentTime = Math.round(new Date().getTime() / 1000, 10);
                }

                window.ec_time = Math.round(new Date().getTime() / 1000, 10) - currentTime;
                window.ec_time_request = 1;

                let agendaStatus = '';
                let liveStatus = '';
                if(currentTime < 1621180800){
                    agendaStatus = 'before';
                }else if(currentTime > 1621180800 && currentTime < 1621353600){
                    agendaStatus = 'middle';
                }else if(currentTime > 1621353600){
                    agendaStatus = 'after';
                }
                store.commit('setAgendaStatus', agendaStatus);

                if(currentTime < 1621209600){
                    liveStatus = 'before';
                }else if(currentTime > 1621209600 && currentTime < 1621353600){
                    liveStatus = 'middle';
                }else if(currentTime > 1621353600){
                    liveStatus = 'after';
                }
                store.commit('setLiveStatus', liveStatus);
                // store.commit('setLiveStatus', 'after');

                // if(currentTime < 1620835200){
                //     store.commit('setOrderStop', false);
                // }
            }
        })
        .catch(err=>{
        });
    }

    // 获取用户登录状态
    if(!store.state.myData.isRequest){
        let loginRes = await api.getUserOrderStatus().catch(function (err) {
            store.commit('setOrderOffline', 0);
            store.commit('setOrderOnline', 0);
            return {status: -1};
        });

        if(loginRes.result == 0){
            store.commit('setGetUserStatusRequest', true);

            let orderOffline = 9;
            let orderOnline = 9;
            if(loginRes.content.status[window.$config.seminarId] == 0){
                // 未预约
                orderOffline = 0;
            }else if(loginRes.content.status[window.$config.seminarId] == 2 || loginRes.content.status[window.$config.seminarId] == 3){
                // 已预约
                orderOffline = 1;
            }else if(loginRes.content.status[window.$config.seminarId] == 1){
                // 审核中
                orderOffline = 2;
            }else if(loginRes.content.status[window.$config.seminarId] == 4){
                // 已拒绝
                orderOffline = 2;
            }else{
                orderOffline = 9;
            }

            if(loginRes.content.status[window.$config.onlineSeminarId] == 0){
                // 未预约
                orderOnline = 0;
            }else if(loginRes.content.status[window.$config.onlineSeminarId] == 2 || loginRes.content.status[window.$config.onlineSeminarId] == 3){
                // 已预约
                orderOnline = 1;
            }else if(loginRes.content.status[window.$config.onlineSeminarId] == 1){
                // 审核中
                orderOnline = 2;
            }else if(loginRes.content.status[window.$config.onlineSeminarId] == 4){
                // 已拒绝
                orderOnline = 3;
            }else{
                orderOnline = 9;
            }

            let userLogin = false;
            if(orderOffline == 1 || orderOffline == 2 || orderOnline == 1){
                userLogin = true;
            }

            store.commit('setOrderOffline', orderOffline);
            store.commit('setOrderOnline', orderOnline);
            store.commit('setIsLogin', true);
            store.commit('setUserLogin', userLogin);
            store.commit('setRelationId', loginRes.content.status.onlineRelation);
            
            let seminarId = '';
            if(orderOffline == 1 || orderOffline == 2){
                seminarId = window.$config.seminarId;
                store.commit('setIsOffline', true);
            }else if(orderOnline == 1){
                seminarId = window.$config.onlineSeminarId;
                store.commit('setIsOnline', true);
            }
            if(seminarId){
                api.mySignupInfo(seminarId)
                .then(res=>{
                })
                .catch(err=>{
                });
            }
        }else{
            store.commit('setOrderOffline', 0);
            store.commit('setOrderOnline', 0);
        }
    }
    

    if (window._hmt) {
        //百度埋码
        if (to.path) {
        if(window.location.href.indexOf('partner2020-minisite')>-1)
        {
            window._hmt.push(['_trackPageview', '/campaign/partner2021-minisite' + to.fullPath]);
        }
        else {
            window._hmt.push(['_trackPageview', '/campaign/ecopartner2021' + to.fullPath]);
        }
        }
    }
    if(to.path === '/home' && from.query.routeFrom==='home') {
        to.meta.keepAlive = true
    } else {
        to.meta.keepAlive = false
    }

    if(!store.state.userLogin && to.path.indexOf('/my') != -1){
        router.push({
            path: 'home', 
        })
    }else{
        next()
    }
});

export default router;